import AllasPlusLogo from '@/allas/public/image/allas-plus-logo.svg';
import bylineFallback from '@/allas/public/image/byline-fallback.png';
import { withNonHTMLChildren } from '@/utils/withNonHTMLChildren';
import { withSafeInnerHTML } from '@/utils/withSafeInnerHTML';
import { StandaloneArticleHeader } from 'base/components/ArticleHeader';

export const AllasStandaloneArticleHeader: typeof StandaloneArticleHeader = ({
  headline,
  isPaidContent,
  ...props
}) => {
  props.bylines?.forEach((byline) => {
    byline.image = byline.image || bylineFallback;
  });

  return <StandaloneArticleHeader  headline={
          <>
            {isPaidContent && (
              <div className="float-left mr-1 h-2 w-6 sm:h-9.5 sm:w-12">
                <AllasPlusLogo />
              </div>
            )}
            <span {...withSafeInnerHTML(headline)}>{withNonHTMLChildren(headline)}</span>
          </>
        }
        {...props} />;
};
